<template>
  <div class="announcements-single is-dismissible">
    <div v-if="announcement.thumbnail"
         class="announcements-single--thumbnail">
        <img :src="announcement.thumbnail">
    </div>
    <div class="announcements-single--body">
      <div class="announcements-single--content" v-html="announcement.content"></div>
      <div v-if="hasAnyButton" class="announcements-single--actions">
        <a
            v-if="hasButton1"
            :href="announcement.button_1_url" target="_blank"
            class="button button-primary">
          {{ announcement.button_1_label }}
        </a>
        <a
            v-if="hasButton2"
            :href="announcement.button_2_url" target="_blank"
            class="button">
          {{ announcement.button_2_label }}
        </a>
        <button
            v-if="hasButtonDismiss"
            @click="dismiss"
            type="button"
            class="button">
          {{ announcement.dismiss_button }}
        </button>
      </div>
    </div>
    <button @click="dismiss" type="button" class="notice-dismiss"></button>
  </div>
</template>

<script>
export default {
  name: 'Notice',

  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasButton1() {
      return this.announcement.button_1_url && this.announcement.button_1_label
    },
    hasButton2() {
      return this.announcement.button_2_url && this.announcement.button_2_label
    },
    hasButtonDismiss() {
      return this.announcement.dismiss_button
    },
    hasAnyButton() {
      return this.hasButton1 || this.hasButton2 || this.hasButtonDismiss
    },
  },

  methods: {
    dismiss() {
      this.$emit('dismiss', this.announcement)
    },
  },
}
</script>

<style lang="scss" scoped>
  .announcements-single {
    background: #fff;
    border: 1px solid #ccd0d4;
    border-left: 4px solid #00a0d2;
    display: flex;
    padding: 12px;
    margin: 0 12px 12px 0;
    position: relative;

    &--thumbnail {
      max-width: 36px;
      max-height: 36px;
      margin-right: 12px;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &--body {
      flex-grow: 1;
    }

    &--content::v-deep {
      h1, h2, h3, h4, h5, h6, p {
        &:first-child {
          margin-top: 0;
        }
      }
    }

    &--actions {
      margin-top: 8px;

      button, a {
        margin-right: 8px;
      }
    }
  }
</style>
